<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">Detail Withdrawal</div>
                <div v-if="role == 5">
                    <div class="filter">
                        <div class="wrap-input">
                            <label class="label-input">Owner</label>
                            <span> : </span>
                            <span>{{ dataDetail.owner }}</span>
                        </div>
                        <div class="wrap-input">
                            <label class="label-input">Total Item</label>
                            <span> : </span>
                            <span>{{ dataDetail.total_item }}</span>
                        </div>
                        <div class="wrap-input">
                            <label class="label-input">Total Weight</label>
                            <span> : </span>
                            <span>{{ dataDetail.total_weight }}</span>
                        </div>
                        <div class="wrap-input" v-if="typeWithdrawal == 'offexchange'">
                            <label class="label-input">Status</label>
                            <span>:</span>
                            <span v-show="dataDetail.status == '001'" class="status-withdrawal request">Processing</span>
                            <span v-show="dataDetail.status == '002'" class="status-withdrawal kbi">Clearing Approve</span>
                            <span v-show="dataDetail.status == '003'" class="status-withdrawal abx">KMI Approve</span>
                            <span v-show="dataDetail.status == '004'" class="status-withdrawal kprk">Client add detail withdrawal</span>
                            <span v-show="dataDetail.status == '005'" class="status-withdrawal operator">Operator Confirmation</span>
                            <span v-show="dataDetail.status == '006'" class="status-withdrawal kbi">Clearing Confirmation</span>
                            <span v-show="dataDetail.status == '007'" class="status-withdrawal handover">KMI Confirmation</span>
                            <span v-show="dataDetail.status == '008'" class="status-withdrawal kprk">Client Withdrawal</span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="filter">
                        <label class="label-input"><b>Withdrawal</b></label>
                        <div class="wrap-input">
                            <label class="label-input">Owner</label>
                            <span>:</span>
                            <span>{{ dataDetail.owner }}</span>
                        </div>
                        <div class="wrap-input">
                            <label class="label-input">Total Item</label>
                            <span>:</span>
                            <span>{{ dataDetail.total_item }}</span>
                        </div>
                        <div class="wrap-input">
                            <label class="label-input">Total Weight</label>
                            <span>:</span>
                            <span>{{ dataDetail.total_weight }} gr</span>
                        </div>
                        <div class="wrap-input" v-if="typeWithdrawal == 'offexchange'">
                            <label class="label-input">Status</label>
                            <span>:</span>
                            <span v-show="dataDetail.status == '001'" class="status-withdrawal request">Processing</span>
                            <span v-show="dataDetail.status == '002'" class="status-withdrawal kbi">Clearing Approve</span>
                            <span v-show="dataDetail.status == '003'" class="status-withdrawal abx">KMI Approve</span>
                            <span v-show="dataDetail.status == '004'" class="status-withdrawal kprk">Client add detail withdrawal</span>
                            <span v-show="dataDetail.status == '005'" class="status-withdrawal operator">Operator Confirmation</span>
                            <span v-show="dataDetail.status == '006'" class="status-withdrawal kbi">Clearing Confirmation</span>
                            <span v-show="dataDetail.status == '007'" class="status-withdrawal handover">KMI Confirmation</span>
                            <span v-show="dataDetail.status == '008'" class="status-withdrawal kprk">Client Withdrawal</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <table>
                        <thead>
                            <tr id="top">
                                <th scope="col" rowspan="2" style="width: 70px">No</th>
                                <th scope="col">Serial Number</th>
                                <th scope="col">Year</th>
                                <th scope="col" rowspan="2" style="width: 120px" v-if="typeWithdrawal == 'onexchange'">Contract</th>
                                <th scope="col" rowspan="2">Weight (gr)</th>
                                <!-- <th scope="col" rowspan="2">Dimension (mm)</th> -->
                                <th scope="col" rowspan="2">Fineness</th>
                                <th scope="col" rowspan="2">Hallmark</th>
                                <!-- <th scope="col" colspan="2">Description</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, i) in dataMetal" :key="i">
                                <td data-label="No">{{ i + 1 }}</td>
                                <td data-label="Serial Number">{{ data.serial_number }}</td>
                                <td data-label="Amount">{{ data.year }}</td>
                                <td data-label="Depasite Date" v-if="typeWithdrawal == 'onexchange'">
                                    <span v-show="data.contract_id == 1">100 Gram Non Pool</span>
                                    <span v-show="data.contract_id == 3">1 KG Non Pool</span>
                                    <span v-show="data.contract_id == 7">0.01 Gram Pool</span>
                                    <span v-show="data.contract_id == 5">0.01 Gram Pool</span>
                                </td>
                                <td data-label="Weight">{{ data.weight }}</td>
                                <!-- <td data-label="Dimension">{{ data.dimension }}</td> -->
                                <td data-label="Fineness">{{ data.fineness }}</td>
                                <td data-label="Hallmark">{{ data.hallmark }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="typeWithdrawal == 'onexchange'">
                        <div v-show="(role == 2 || role == 3) && (withdrawal_status == '002' || withdrawal_status == '010')">
                            <!-- <b-button class="mr-2" variant="danger">Save as Draft</b-button> -->
                            <b-button class="ml-2" variant="success" @click="processWithdrawl">
                                <span v-show="!loadingWithdrawal">Process</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingWithdrawal"></b-spinner>
                            </b-button>
                        </div>
                        <!-- ======= Approve Operator ======= -->
                        <div v-show="role == 5 && withdrawal_status == '002'">
                            <b-button class="ml-2" variant="success" @click="processWithdrawl">
                                <span v-show="!loadingWithdrawal">Process</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingWithdrawal"></b-spinner>
                            </b-button>
                        </div>
                        <!-- ======= Approve KBI ======= -->
                        <div v-show="role == 1 && withdrawal_status == '001'">
                            <b-button class="ml-2" variant="success" @click="apprveKBI">
                                <span v-show="!loadingKbi">Process</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingKbi"></b-spinner>
                            </b-button>
                        </div>
                    </div>

                    <div v-else>
                        <div v-show="(role == 2 || role == 3) && withdrawal_status == '002'">
                            <b-button class="ml-2" variant="success" @click="approveOfexchange">
                                <span v-show="!loadingWithdrawal">Process</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingWithdrawal"></b-spinner>
                            </b-button>
                        </div>

                        <div v-show="role == 5 && withdrawal_status == '004'">
                            <b-button class="ml-2" variant="success" @click="approveOfexchange">
                                <span v-show="!loadingWithdrawal">Process</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingWithdrawal"></b-spinner>
                            </b-button>
                        </div>

                        <div v-show="(role == 2 || role == 3) && withdrawal_status == '006'">
                            <b-button class="ml-2" variant="success" @click="openModal"> Process </b-button>
                        </div>
                    </div>
                    <b-modal ref="modal-withdraw" hide-footer title="Input Document Withdraw">
                        <form action="">
                            <div class="text-center mb-3">
                                <label class="upload-video">
                                    <span v-if="!loadDataManu"> <b-icon icon="upload" class="mr-1 icon-upload"></b-icon> Choose File </span>
                                    <b-spinner small variant="ligth" v-else></b-spinner>
                                    <input type="file" accept="image/*, application/pdf" ref="withdraw" @change="onWithdrawDoc" />
                                </label>
                                <div id="imageName" class="ml-3">{{ label_Withdraw }}</div>
                                <!-- <div v-if="$v.form_attachment.manufacturing_doc.$error">
                  <span v-if="!$v.form_attachment.manufacturing_doc.required" class="error">File required</span>
                </div> -->
                            </div>
                            <div class="d-flex justify-content-end mt-5">
                                <b-button variant="light" size="sm" @click="closeModal">Cancel</b-button>
                                <b-button class="ml-2" variant="success" size="sm" @click="confirmationOfexchange">
                                    <span v-show="!loadingWithdrawal">Submit</span>
                                    <b-spinner label="Loading..." variant="light" small v-show="loadingWithdrawal"></b-spinner>
                                </b-button>
                            </div>
                        </form>
                    </b-modal>
                    <!-- ======= Approve ABX ======= -->
                    <!-- <b-pagination
            v-model="currentPage"
            :total-rows="lengthData"
            :per-page="perPage"
            @change="handlePageChange"
            aria-controls="new-table"
            first-number
            last-number
            v-show="lengthData > 10"
          ></b-pagination> -->

                    <!-- ======== Modal ABX ======== -->

                    <b-modal ref="my-modal" hide-footer title="Input Detail Metal">
                        <div class="d-block text-center">
                            <form action="">
                                <div class="form-group">
                                    <label for="" class="text-left">Allocated</label>
                                    <select name="" id="" v-model="form.allocated" class="select-input">
                                        <option value=""></option>
                                        <option value="allocated">Allocated</option>
                                        <option value="non allocated">Non Allocated</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="" class="text-left">Hub</label>
                                    <input type="text" v-model="form.hub" readonly />
                                </div>
                                <div class="form-group">
                                    <label class="text-left">Dimension (mm<sup>3</sup>) </label>
                                    <input type="text" v-model="form.dimension" />
                                </div>
                                <div class="form-group">
                                    <label class="text-left">Fineness</label>
                                    <input type="text" v-model="form.fineness" />
                                </div>
                                <div class="form-group">
                                    <label class="text-left">Hallmark</label>
                                    <input type="text" v-model="form.hallmark" />
                                </div>
                                <div class="form-group">
                                    <label class="text-left">Serial Number</label>
                                    <input type="text" v-model="form.serial_number" />
                                </div>
                                <div class="form-group">
                                    <label class="text-left">Year</label>
                                    <input type="text" v-model="form.year" />
                                </div>
                            </form>
                        </div>
                        <div class="d-flex justify-content-end mt-5">
                            <b-button class="mr-2" variant="outline-danger" @click="hideModal">Cancel</b-button>
                            <b-button class="ml-2" variant="success" @click="submitMetal">
                                <span v-show="!loadingMetal">Submit</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingMetal"></b-spinner>
                            </b-button>
                        </div>
                    </b-modal>

                    <!-- ======== Modal Operator ========= -->
                    <b-modal ref="modal-operator" hide-footer title="Confirmation Metal">
                        <div class="d-block text-center">
                            <h3 v-show="status_operator == 1">Are You Sure to Accept this Metal?</h3>
                            <h3 v-show="status_operator == 2">Are You Sure to Reject this Metal?</h3>
                        </div>
                        <div class="d-flex justify-content-end mt-5">
                            <b-button class="mr-2" variant="outline-danger" @click="hideModalOperator">Cancel</b-button>
                            <b-button class="ml-2" variant="success" @click="operatorKonfirmation">
                                <span v-show="!loadingOperatorConfirm">Submit</span>
                                <b-spinner label="Loading..." variant="light" small v-show="loadingOperatorConfirm"></b-spinner>
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
// import axios from "axios";
export default {
    components: {},
    data() {
        return {
            loadingOperatorConfirm: false,
            loadingWithdrawal: false,
            loadingKbi: false,
            loadingMetal: false,
            showDetailholding: false,
            loadDataManu: false,
            typeWithdrawal: "",
            label_Withdraw: "",
            dataMetal: [],
            dataDetail: [],
            dataHolding: [],
            detailMetal: [],
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            metal_id: "",
            withdrawal_id: "",
            status_operator: "",
            offset: 0,
            withdrawal_status: "",
            role: "",
            infoLocation: "",
            form: {
                allocated: "",
                hub: "",
                dimension: "",
                fineness: "",
                hallmark: "",
                serial_number: "",
                year: "",
            },
            fileWithdraw: "",
        };
    },
    mounted() {
        // this.getData(this.currentPage);
        this.withdrawal_id = this.$route.params.id;
        this.role = sessionStorage.getItem("role");
        let url;
        if (this.role == 5) {
            url = "/v2/clearing/operator/get/detail/withdrawal/" + this.withdrawal_id;
        } else if (this.role == 2 || this.role == 3 || this.role == 7) {
            url = "/v2/clearing/admin/abx/get/detail/withdrawal/" + this.withdrawal_id;
        } else if (this.role == 6) {
            url = "/v1/clearing/admin/get/detail/bullion/" + this.withdrawal_id;
        }
        axios.get(url).then((res) => {
            this.dataMetal = res.data.data.body.metal_info;
            this.dataDetail = res.data.data.body;
            this.typeWithdrawal = this.dataDetail.type;
            this.dataHolding = res.data.data.body.holding;
            this.withdrawal_status = res.data.data.body.status;

            for (let i = 0; i < this.dataMetal.length; i++) {
                this.form.allocated = this.dataMetal[i].allocated;
                this.form.hub = this.dataMetal[i].hub;
                this.form.dimension = this.dataMetal[i].dimension;
                this.form.fineness = this.dataMetal[i].fineness;
                this.form.hallmark = this.dataMetal[i].hallmark;
                this.form.serial_number = this.dataMetal[i].serial_number;
                this.form.year = this.dataMetal[i].year;
            }
        });
    },
    methods: {
        handlePageChange(value) {
            this.getData(value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        getData(value) {
            let offset = (value - 1) * this.perPage;
            console.log(offset);
        },
        showModalOperator(id, status) {
            this.status_operator = status;
            this.metal_id = id;
            this.$refs["modal-operator"].show();
        },
        hideModalOperator() {
            this.$refs["modal-operator"].hide();
        },
        openModal() {
            this.$refs["modal-withdraw"].show();
        },
        closeModal() {
            this.$refs["modal-withdraw"].hide();
        },
        onWithdrawDoc() {
            this.loadDataManu = true;
            const fileWithdraw = this.$refs.withdraw.files[0];
            if (
                fileWithdraw.type == "image/jpeg" ||
                fileWithdraw.type == "image/jpg" ||
                fileWithdraw.type == "image/png" ||
                fileWithdraw.type == "application/pdf"
            ) {
                this.requestFormData(fileWithdraw).then((res) => {
                    this.loadDataManu = false;
                    this.label_Withdraw = fileWithdraw.name;
                    this.fileWithdraw = res.data.data;
                });
            }
        },
        showModal(data) {
            this.detailMetal = data;
            this.form.serial_number = data.serial_number;
            this.form.year = data.year;
            this.metal_id = data._id;
            this.form._id = data._id;
            this.$refs["my-modal"].show();
        },
        hideModal() {
            this.$refs["my-modal"].hide();
        },

        requestFormData(fileData) {
            let formData = new FormData();
            formData.append("file", fileData);
            return axios.post("/v2/upload/external", formData);
        },

        operatorKonfirmation() {
            this.loadingOperatorConfirm = true;
            let value;
            if (this.status_operator == 1) {
                value = "accept";
            } else {
                value = "reject";
            }
            // console.log(value);
            axios
                .put("/v2/clearing/operator/metal/confirmation", { metal_id: this.metal_id, option: value })
                .then((res) => {
                    if (res.status == 200) {
                        this.loadingOperatorConfirm = false;
                        this.$toast.success(res.data.message, {
                            position: "top-center",
                            timeout: 3000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                        setTimeout(function () {
                            location.reload();
                        }, 3000);
                    }
                })
                .catch((err) => {
                    this.loadingOperatorConfirm = false;
                    this.$toast.error(err.response.data.message, {
                        position: "top-center",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        showCloseButtonOnHover: false,
                        hideProgressBar: false,
                        closeButton: "button",
                        icon: true,
                        rtl: false,
                    });
                });
        },
        submitMetal() {
            this.loadingMetal = true;
            axios
                .put("/v2/clearing/admin/abx/add/metal_detail", this.form)
                .then((res) => {
                    if (res.status == 200) {
                        this.loadingMetal = false;
                        this.$toast.success("Add Detail Metal Success");
                        setTimeout(function () {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.loadingMetal = false;
                    this.$toast.error(error.response.data.message);
                });
        },
        processWithdrawl() {
            this.loadingWithdrawal = true;
            let url;
            if (this.role == 2 || this.role == 3) {
                url = "/v2/clearing/admin/abx/withdrawal/confirmation";
            } else if (this.role == 5) {
                url = "/v2/clearing/operator/withdrawal/confirmation";
            }
            this.$store.dispatch("getLocation").then((resGeo) => {
                let info;
                if (resGeo.cityData[0]) {
                    info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    info = JSON.stringify(data);
                }

                axios
                    .put(url, { _id: this.withdrawal_id, info: info })
                    .then((res) => {
                        if (res.status == 200) {
                            this.loadingWithdrawal = false;
                            this.$toast.success(res.data.message);
                            setTimeout(function () {
                                location.reload();
                            }, 3000);
                        }
                    })
                    .catch((err) => {
                        this.loadingWithdrawal = false;
                        this.$toast.error(err.response.data.message);
                    });
            });
        },
        apprveKBI() {
            this.loadingKbi = true;
            axios
                .put("/v1/clearing/admin/withdrawal/confirmation/" + this.withdrawal_id)
                .then((res) => {
                    if (res.status == 200) {
                        this.loadingKbi = false;
                        this.$toast.success(res.data.message);
                        setTimeout(function () {
                            location.reload();
                        }, 3000);
                    }
                })
                .catch((err) => {
                    this.loadingKbi = false;
                    this.$toast.error(err.response.data.message);
                });
        },
        approveOfexchange() {
            this.loadingWithdrawal = true;
            let url;
            if (this.role == 2 || this.role == 3) {
                url = "/v2/clearing/admin/abx/offexchange/withdrawal/update";
            } else if (this.role == 5) {
                url = "/v2/clearing/operator/offexchange/withdrawal/update";
            }
            this.$store.dispatch("getLocation").then((resGeo) => {
                let info;
                if (resGeo.cityData[0]) {
                    info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    info = JSON.stringify(data);
                }

                axios
                    .put(url, { _id: this.withdrawal_id, info: info })
                    .then((res) => {
                        console.log(res);
                        if (res.status == 200) {
                            this.loadingWithdrawal = false;
                            this.$toast.success(res.data.message);
                            setTimeout(function () {
                                location.reload();
                            }, 3000);
                        }
                    })
                    .catch((err) => {
                        this.loadingWithdrawal = false;
                        this.$toast.error(err.response.data.message);
                    });
            });
        },
        confirmationOfexchange() {
            this.loadingWithdrawal = true;
            let url;
            if (this.role == 2 || this.role == 3) {
                url = "/v2/clearing/admin/abx/offexchange/withdrawal/confirmation";
            } else if (this.role == 5) {
                url = "/v2/clearing/operator/offexchange/withdrawal/update";
            }
            this.$store.dispatch("getLocation").then((resGeo) => {
                let info;
                if (resGeo.cityData[0]) {
                    info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    info = JSON.stringify(data);
                }

                axios
                    .put(url, { _id: this.withdrawal_id, info: info, withdrawal_doc: this.fileWithdraw })
                    .then((res) => {
                        if (res.status == 200) {
                            this.loadingWithdrawal = false;
                            this.$toast.success(res.data.message);
                            setTimeout(function () {
                                location.reload();
                            }, 3000);
                        }
                    })
                    .catch((err) => {
                        this.loadingWithdrawal = false;
                        this.$toast.error(err.response.data.message);
                    });
            });
        },
    },
    computed: {
        rows() {
            return (this.currentPage - 1) * this.perPage;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.fa-check {
    color: #28a745;
    cursor: pointer;
}
.fa-times {
    color: #dc3545;
    cursor: pointer;
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

label {
    width: 50%;
}

.select-input,
input {
    width: 100%;
}

.form-group {
    display: flex;
}

.select-input,
input {
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 0 10px;
    font-size: 13px;
}

.label-form {
    display: block;
    width: 100%;
    font-weight: bold;
}

.upload-video {
    border: 1px solid #1f354a;
    padding: 0.5rem;
    color: #1f354a;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    font-weight: bold;
    width: 7rem;
    text-align: center;
}

.upload-video:hover {
    background: #1f354a;
    color: #ffffff;
}

.icon-upload {
    font-size: 13px;
}

#inputTag {
    display: none;
}

input[type="file"] {
    display: none;
}

.form-input {
    width: 50%;
    border-radius: 5px;
    border: none;
    padding: 0.5rem 1rem;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-input:focus {
    border-color: var(--clr-primary);
    outline: 0;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.buuton-add {
    text-align: right;
    font-size: 13px;
}

.content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-top: 15px;
}

.icon-trade {
    width: 25px;
}

.footer {
    background: var(--clr-primary);
    color: white;
    padding: 20px 47px;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 62px;
}

.filter {
    display: table-cell;
    width: 40%;
    font-size: 12px;
}
.wrap-input {
    display: flex;
    gap: 0.5rem;
}

.label-input {
    width: 5rem;
}

.button-more {
    cursor: pointer;
    margin-bottom: 0.4rem;
    display: flex;
    align-items: center;
    gap: 1.3rem;
    font-weight: bold;
}

.icons {
    transition: all 0.3s ease-out;
}

.rotateIcons {
    transform: rotate(180deg);
}

select {
    width: 130px;
    border-radius: 3px;
    border-color: #a5a5a5a5;
    padding: 3px;
}

.card {
    width: 314px;
    font-size: 14px;
    border-radius: 10px;
}

.card-header {
    padding: 1rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    position: relative;
    left: 20px;
}

.title::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--clr-scondary);
    left: -17px;
    top: 3px;
}

.buyer {
    margin-bottom: 20px;
}

.content-right {
    text-align: right;
}

.amount {
    font-weight: bold;
}

.btn-primer {
    background: var(--clr-scondary);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-primer:hover {
    background-color: var(--clr-scondary-hover);
}

.status-allocated {
    font-weight: 600;
    color: #2dce89;
}

.status-processed {
    font-weight: 600;
    color: rgb(172, 143, 26);
}

.status-rejected {
    font-weight: 600;
    color: #f5365c;
}

.request {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(252, 108, 4);
    border-radius: 5px;
}
.abx {
    /* background: rgba(172, 143, 26, 0.1); */
    font-weight: 600;
    color: rgb(172, 143, 26);
    border-radius: 5px;
}
.operator {
    /* background: rgba(89, 37, 25, 0.1); */
    font-weight: 600;
    color: rgb(89, 37, 25);
    border-radius: 5px;
}
.kbi {
    /* background: rgba(60, 60, 92, 0.1); */
    font-weight: 600;
    color: rgb(60, 60, 92);
    border-radius: 5px;
}
.shipping {
    /* background: rgba(188, 180, 179, 0.1); */
    font-weight: 600;
    color: rgb(54, 255, 14);
    border-radius: 5px;
}
.handover {
    /* background: rgba(50, 90, 115, 0.1); */
    font-weight: 600;
    color: rgb(50, 90, 115);
    border-radius: 5px;
}
.kprk {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(252, 108, 4);
    border-radius: 5px;
}
.nasabah {
    /* background: rgba(40, 167, 69, 0.1); */
    font-weight: 600;
    color: rgb(40, 167, 69);
    border-radius: 5px;
}
.decline {
    /* background: rgba(220, 53, 69, 0.1); */
    font-weight: 600;
    color: rgb(220, 53, 69);
    border-radius: 5px;
}
</style>
